export default __webpack_public_path__ + "static/media/empty_image.9bfb130d.png";